import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { IsEmpty, returnFirstTier, seriesHeader } from "../../util/commonFunctions";
import { logout, setSignupModalStatus } from "../../actions";
import Notification from "../notification";
import cosmeticConfig from "../../../config/cosmeticConfig";


let setIntervar = null;
let interval = 100;
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLive: true,
      showSignin: true
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.props.location.pathname === "/") {
      this.setState({
        showLive: false
      });
    }
    let refrence = this;
    setIntervar = setInterval(() => {
      refrence.applyMarginOnHeader();
    }, interval);
  }

  applyMarginOnHeader = () => {
    const list = document
      .getElementsByClassName("header-left-block")?.[0]
      ?.querySelectorAll("li.nav-item");
    if (list?.length >= 2) {
      for (let headerItem of list) {
        if (headerItem.querySelector(".childTier")) {
          headerItem.querySelector(
            ".childTier"
          ).firstElementChild.style.marginLeft = headerItem.offsetLeft;
        }
      }
      clearInterval(setIntervar);
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(props) {
    if (props.location.pathname !== this.props.location.pathname) {
      if (
        this.props.location.pathname.indexOf("profile") > 0 ||
        this.props.location.pathname.indexOf("media") > 0 ||
        this.props.location.pathname === "/" ||
        this.props.location.pathname.indexOf("topic") > 0 ||
        this.props.location.pathname.indexOf("for-you") > 0 ||
        this.props.location.pathname.indexOf("follow-management") > 0
      ) {
        this.setState({ showLive: true });
      }
      if (this.props.location.pathname === "/")
        this.setState({ showLive: false });
      this.setState({ showSignin: true });
    } else {
      const location = this.props.location.pathname;
      const nodes = this.props.nodeTier;
      let activeNav = null;
      if (location !== "/"){
        activeNav = nodes &&
        nodes.findIndex(
          e => {
              let result = false;
              if (e.navLabel !== ""){
                  if (location.includes(e.name)){
                    result = true;
                  }
              } else {
                if (location.includes(e.name)){
                  result = true;
                }
              }
          }
        );
      }
      activeNav !== -1 && activeNav !== null
        ? document
          .querySelectorAll(".header-left-block .nav-item")
        [activeNav].classList.add("tier1NavMenu")
        : null;
      if (location == '/for-you' && document.querySelectorAll(".for-you-nav").length > 0) { // for you active case
        document.querySelectorAll(".for-you-nav")
        [0].classList.add("tier1NavMenu");
      }
    }
  }

  handleScroll = function (event) {
  };

  logout = () => {
    this.props.onLogout();
    this.props.history.push("/");
    if (
      document.getElementsByClassName("liClass") &&
      document.getElementsByClassName("liClass")[0]
    ) {
      document.getElementsByClassName("liClass")[0].classList.remove("active");
      document.getElementsByClassName("tokenValid")[0].classList.add("mainContainer");
      document.getElementsByClassName("tokenValid")[0].classList.remove("tokenValid");
    }
  };
  menuOpen = () => {
    this.props.popup();
  };
  toggleActiveOnClick = event => {
    if (
      document.getElementsByClassName("header-right").length > 0 &&
      document
        .getElementsByClassName("header-right")[0]
        .querySelectorAll("li.liClass").length > 0 &&
      event.target.closest("li.liClass") != null
    ) {
      event.target
        .closest("li.liClass")
        .querySelector(
          ".childTier"
        ).firstElementChild.style.marginLeft = event.target.closest(
          "li.liClass"
        ).offsetLeft;
    }
    document
      .getElementsByClassName("header-right")[0]
      .querySelectorAll("li.liClass");

    if (event.target.closest("li").classList.contains("active")) {
      event.target.closest("li").classList.remove("active");
    } else {
      event.target.closest("li").classList.add("active");
    }
  };
  onMouseEnter = event => {
    if (event.target.querySelector(".childTier")) {
      event.target.querySelector(
        ".childTier"
      ).firstElementChild.style.marginLeft = event.target.offsetLeft;
    }
  };
  onMouseLeave = event => { };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  openSigninModalPopup = (formName) => {
    this.props.setSignupModalStatus(true, formName);
  };

  render() {
    return (
      <header
        className={`${this.props.isloggedin
          ? "headerLoggedIn"
          : `${this.props.isSignupView
            ? "headerLoggedOut signupView"
            : "headerLoggedOut"
          }`
          }`}
      >
        <div className="header-container">
          <div className="header-left-block">
            <a className="menu_icon" onClick={() => this.menuOpen()}>
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </a>
            <div className="site-logo">
              <Link to="/">
                <img className="logo" src="/assets/logo.png" alt="Logo Image" />
              </Link>
            </div>
            <div className="main-menu">
              <ul className="d-flex">
                {this.props.nodeTier && this.props.nodeTier.length != null &&
                  <li className={this.props.location.pathname == "/for-you" ? "nav-item for-you-nav tier1NavMenu" : "nav-item for-you-nav"}>
                    <Link to="/for-you">For You</Link>
                  </li>
                }
                {this.props.nodeSeries && !IsEmpty(this.props.nodeSeries) &&
                  <li className="nav-item" onMouseEnter={event => this.onMouseEnter(event)} >
                    <span>Series</span>
                    <ul className="childTier">
                      {
                        seriesHeader(
                          this.props.nodeSeries,
                          cosmeticConfig.header.MAX_IN_A_ROW,
                          this
                        )
                      }
                    </ul>
                  </li>
                }
                {this.props.nodeTier && this.props.nodeTier.length < cosmeticConfig.header.MAX_IN_A_ROW ? (
                  <React.Fragment>
                    {returnFirstTier(
                      this.props.nodeTier,
                      cosmeticConfig.header.MAX_IN_A_ROW,
                      "nav-item",
                      "",
                      "childTier",
                      this.toggleActiveOnClick,
                      this.onMouseEnter,
                      this.onMouseLeave
                    )}
                  </React.Fragment>
                ) : !IsEmpty(this.props.nodeTier) ? (
                  returnFirstTier(
                    this.props.nodeTier.slice(0, cosmeticConfig.header.MAX_IN_A_ROW),
                    cosmeticConfig.header.MAX_IN_A_ROW,
                    "nav-item",
                    "",
                    "childTier",
                    this.toggleActiveOnClick,
                    this.onMouseEnter,
                    this.onMouseLeave
                  )
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
          <div className="header-right-block main-menu">
            <ul>
              <li>
                <a target="_blank" href="https://info.ausbiz.com.au/en-au/contributors">
                  <button className="custom-contribution-button">
                    Support ausbiz
                  </button>
                </a>
              </li>
              <li className="header-search">
                <div className="header-search-filter">
                  <Link to="/search">
                    <input type="text" className="header-search-fld" placeholder="Search for companies, experts, videos & more" />
                  </Link>
                </div>
                <Link to="/search" className="searchIcon nav-item">
                  <img src="/assets/svg/search-white.svg" />
                </Link>
              </li>
              {this.state.showSignin ? (
                <React.Fragment>
                  {!IsEmpty(this.props.userProfile) &&
                    <Notification
                      notification={this.props.notification}
                      updateNotificationReadStatus={this.props.updateNotificationReadStatus}
                      showNotification={this.props.showNotification}
                      toggleNotification={this.props.toggleNotification}
                    />
                  }
                  <li className="liClass profile-info">
                    {!IsEmpty(this.props.userProfile) ? (
                      <React.Fragment>
                        <span
                          className={`person ${this.props.isloggedin ? "loginPerson" : ""
                            }`}
                          onClick={event => this.toggleActiveOnClick(event)}
                        >
                          {this.props.userProfile.profilePictureUrl ? (
                            <React.Fragment>
                              <img
                                className="avatar"
                                src={this.props.userProfile.profilePictureUrl}
                              />
                              {this.props.userProfile.firstName}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <img
                                className="avatar"
                                src="/assets/svg/profile-active.svg"
                              />
                              {this.props.userProfile.firstName}
                            </React.Fragment>
                          )}
                        </span>
                        <span className="caretDropdown"></span>
                        <ul className="childTier userDropdown">
                          <ul>
                            <li>
                              <Link to="/follow-management">Watchlist</Link>
                            </li>
                            <li>
                              <a
                                id="callBeamer"
                                data-beamer-keypress="true"
                              >
                                What's New
                              </a></li>
                            <li>
                              <Link to="/profile/personal">My Profile</Link>
                            </li>
                            <li>
                              <span
                                className="logout"
                                onClick={() => this.logout()}
                              >
                                Sign out
                              </span>
                            </li>
                          </ul>
                        </ul>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <img
                          className="avatar-nologin"
                          src="/assets/svg/profile-active.svg"
                        />
                        <span
                          data-toggle="modal"
                          data-target="#signInModal"
                          onClick={() => this.openSigninModalPopup("signin")}
                          className="person nav-item"
                        >
                          Sign in
                        </span>
                        {/* DO NOT REMOVE THIS BEAMER CODE */}
                        <a
                          id="callBeamer"
                          data-beamer-keypress="true"
                          style={{ visibility: "hidden", display: 'none' }}
                        >
                          What's New
                        </a>
                      </React.Fragment>
                    )}
                  </li>
                </React.Fragment>
              ) : null}
            </ul>
          </div>
        </div>
      </header >
    );
  }
}

const mapStateToProps = state => {
  return {
    userProfile: state.auth.userProfile
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(logout()),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
